import { ValidatedScripts } from './response-data-validator';
import { ThirdPartyScriptDefinition } from './types';
import { BinobanScript } from './scripts/binoban';
import { ClarityScript } from './scripts/clarity';
import { DeemaScript } from './scripts/deema';
import { DezhinoScript } from './scripts/dezhino';
import { GoftinoScript } from './scripts/goftino';
import { GTMBodyScript } from './scripts/gtm-body';
import { GTMHeadScript } from './scripts/gtm-head';
import { MediaadScript } from './scripts/mediaad';
import { WebengageScript } from './scripts/webengage';
import { YektanetScript } from './scripts/yektanet';
export const thirdPartyScriptRegistry = {
  gtm: {
    placement: 'head',
    render: (thirdPartyData: ValidatedScripts) => <GTMHeadScript gtmData={thirdPartyData.gtm} />
  },
  binoban: {
    placement: 'head',
    render: (thirdPartyData: ValidatedScripts) => <BinobanScript binobanData={thirdPartyData.binoban} />
  },
  clarity: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <ClarityScript clarityData={thirdPartyData.clarity} />
  },
  gtmBody: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <GTMBodyScript gtmData={thirdPartyData.gtm} />
  },
  webengage: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <WebengageScript webengageData={thirdPartyData.webengage} />
  },
  goftino: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <GoftinoScript goftinoData={thirdPartyData.goftino} />
  },
  deema: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <DeemaScript deemaData={thirdPartyData.deema} />
  },
  yektanet: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <YektanetScript yektanetData={thirdPartyData.yektanet} />
  },
  mediaad: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <MediaadScript mediaadData={thirdPartyData.mediaad} />
  },
  dezhino: {
    placement: 'body',
    render: (thirdPartyData: ValidatedScripts) => <DezhinoScript dezhinoData={thirdPartyData.dezhino} />
  }
} satisfies Record<string, ThirdPartyScriptDefinition>;